const organization_details = {
    page_title: 'รายละเอียดองค์กร',
    delete_confirmation: 'เมื่อถูกลบ สมาชิกทั้งหมดจะสูญเสียการเป็นสมาชิกและบทบาทในองค์กรนี้ การดำเนินการนี้ไม่สามารถยกเลิกได้',
    organization_id: 'รหัสองค์กร',
    settings_description: 'องค์กรหมายถึงทีม ลูกค้าธุรกิจ และบริษัทคู่ค้าที่สามารถเข้าถึงแอปพลิเคชันของคุณได้',
    name_placeholder: 'ชื่อองค์กร ไม่จำเป็นต้องไม่ซ้ำกัน',
    description_placeholder: 'คำอธิบายขององค์กร',
    member: 'สมาชิก',
    member_other: 'สมาชิก',
    add_members_to_organization: 'เพิ่มสมาชิกไปยังองค์กร {{name}}',
    add_members_to_organization_description: 'ค้นหาผู้ใช้ที่เหมาะสมโดยการค้นหาชื่อ อีเมล เบอร์โทรศัพท์ หรือรหัสผู้ใช้ สมาชิกที่มีอยู่จะไม่แสดงในผลการค้นหา',
    add_with_organization_role: 'เพิ่มด้วยบทบาทขององค์กร',
    user: 'ผู้ใช้',
    application: 'แอปพลิเคชัน',
    application_other: 'แอปพลิเคชัน',
    add_applications_to_organization: 'เพิ่มแอปพลิเคชันไปยังองค์กร {{name}}',
    add_applications_to_organization_description: 'ค้นหาแอปพลิเคชันที่เหมาะสมโดยการค้นหา app ID ชื่อ หรือคำอธิบาย แอปพลิเคชันที่มีอยู่แล้วจะไม่แสดงในผลการค้นหา',
    at_least_one_application: 'ต้องมีแอปพลิเคชันอย่างน้อยหนึ่งรายการ',
    remove_application_from_organization: 'ลบแอปพลิเคชันออกจากองค์กร',
    remove_application_from_organization_description: 'เมื่อถูกลบ แอปพลิเคชันนี้จะสูญเสียการเชื่อมโยงและบทบาทในองค์กรนี้ การดำเนินการนี้ไม่สามารถยกเลิกได้',
    search_application_placeholder: 'ค้นหาโดย app ID ชื่อ หรือคำอธิบาย',
    roles: 'บทบาทขององค์กร',
    authorize_to_roles: 'ให้สิทธิ์ {{name}} ในการเข้าถึงบทบาทต่อไปนี้:',
    edit_organization_roles: 'แก้ไขบทบาทขององค์กร',
    edit_organization_roles_title: 'แก้ไขบทบาทขององค์กรของ {{name}}',
    remove_user_from_organization: 'ลบผู้ใช้ออกจากองค์กร',
    remove_user_from_organization_description: 'เมื่อถูกลบ ผู้ใช้จะสูญเสียการเป็นสมาชิกและบทบาทในองค์กรนี้ การดำเนินการนี้ไม่สามารถยกเลิกได้',
    search_user_placeholder: 'ค้นหาชื่อ อีเมล เบอร์โทรศัพท์ หรือรหัสผู้ใช้',
    at_least_one_user: 'ต้องมีผู้ใช้อย่างน้อยหนึ่งคน',
    organization_roles_tooltip: 'บทบาทที่มอบให้{{type}}ในองค์กรนี้',
    custom_data: 'ข้อมูลกำหนดเอง',
    custom_data_tip: 'ข้อมูลกำหนดเองเป็นวัตถุ JSON ที่สามารถใช้เก็บข้อมูลเพิ่มเติมที่เกี่ยวข้องกับองค์กร',
    invalid_json_object: 'วัตถุ JSON ไม่ถูกต้อง',
    branding: {
        logo: 'โลโก้องค์กร',
        logo_tooltip: 'คุณสามารถใส่รหัสองค์กรเพื่อแสดงโลโก้นี้ในหน้าลงชื่อเข้าใช้ จำเป็นต้องมีเวอร์ชันดำของโลโก้หากมีการเปิดใช้งานโหมดมืดในการตั้งค่าประสบการณ์ลงชื่อเข้าใช้แบบ omni <a>เรียนรู้เพิ่มเติม</a>',
    },
    jit: {
        title: 'การสร้างบัญชีแบบทันที (Just-in-time provisioning)',
        description: 'ผู้ใช้สามารถเข้าร่วมองค์กรและได้รับบทบาทโดยอัตโนมัติในการลงชื่อเข้าใช้ครั้งแรกผ่านวิธีพิสูจน์ตัวตนบางแบบ คุณสามารถตั้งเงื่อนไขสำหรับการสร้างบัญชีแบบทันทีได้',
        email_domain: 'การสร้างบัญชีด้วยโดเมนอีเมล',
        email_domain_description: 'ผู้ใช้ใหม่ที่ลงทะเบียนด้วยอีเมลที่ยืนยันแล้วหรือผ่าน social sign-in ที่ยืนยันอีเมลจะเข้าร่วมองค์กรโดยอัตโนมัติ <a>เรียนรู้เพิ่มเติม</a>',
        email_domain_placeholder: 'ป้อนโดเมนอีเมลสำหรับการสร้างบัญชีแบบทันที',
        invalid_domain: 'โดเมนไม่ถูกต้อง',
        domain_already_added: 'โดเมนนี้ถูกเพิ่มแล้ว',
        sso_enabled_domain_warning: 'คุณได้ป้อนโดเมนอีเมลที่เชื่อมโยงกับ SSO สำหรับองค์กร ผู้ใช้ที่มีอีเมลเหล่านี้จะเข้าสู่กระบวนการ SSO ปกติและจะไม่ได้รับการเพิ่มเข้าองค์กรนี้โดยอัตโนมัติ เว้นแต่มีการตั้งค่า SSO provisioning สำหรับองค์กรแล้ว',
        enterprise_sso: 'การสร้างบัญชีผ่าน SSO สำหรับองค์กร',
        no_enterprise_connector_set: 'คุณยังไม่ได้ตั้งค่าตัวเชื่อมต่อ SSO สำหรับองค์กร เพิ่มตัวเชื่อมต่อก่อนเพื่อเปิดใช้ SSO provisioning สำหรับองค์กร <a>ตั้งค่า</a>',
        add_enterprise_connector: 'เพิ่มตัวเชื่อมต่อ SSO สำหรับองค์กร',
        enterprise_sso_description: 'ผู้ใช้ใหม่หรือผู้ใช้ที่เข้าสู่ระบบผ่าน SSO สำหรับองค์กรเป็นครั้งแรกจะเข้าร่วมองค์กรนี้โดยอัตโนมัติ <a>เรียนรู้เพิ่มเติม</a>',
        organization_roles: 'บทบาทองค์กรเริ่มต้น',
        organization_roles_description: 'กำหนดบทบาทให้ผู้ใช้เมื่อเข้าร่วมองค์กรผ่านการสร้างบัญชีแบบทันที',
    },
    mfa: {
        title: 'การยืนยันตัวตนหลายปัจจัย (MFA)',
        tip: 'เมื่อบังคับให้ใช้ MFA ผู้ใช้ที่ไม่ได้ตั้งค่า MFA จะไม่สามารถแลก token ขององค์กรได้ การตั้งค่านี้ไม่มีผลกับการพิสูจน์ตัวตนผู้ใช้',
        description: 'บังคับให้ผู้ใช้ตั้งค่าการยืนยันตัวตนหลายปัจจัยในการเข้าถึงองค์กรนี้',
        no_mfa_warning: 'ยังไม่มีวิธีการยืนยันตัวตนหลายปัจจัยเปิดใช้งานสำหรับผู้เช่า ผู้ใช้จะไม่สามารถเข้าถึงองค์กรนี้ได้จนกว่าจะเปิดใช้งาน <a>วิธีการยืนยันตัวตนหลายปัจจัย</a> อย่างน้อยหนึ่งวิธี',
    },
};
export default Object.freeze(organization_details);
